<template>
  <div class="sky-page-function-view">
    <div class="page-function-toolbar wsp-width-100">
      <el-button icon="el-icon-refresh" @click="getData"></el-button>
      <el-input
        placeholder="请输入功能名称/价值进行查询"
        class="toolbar-input"
        size="medium"
        v-model="searchKeyword"
        autocomplete="off"
        @blur="searchReq"
        @change="searchReq"
      >
        <span slot="suffix" class="el-input__suffix" @click="searchReq"
          ><span class="el-input__suffix-inner"> <i class="el-input__icon el-icon-search"></i></span>
        </span>
      </el-input>
      <el-dropdown trigger="click" v-if="!isChannel">
        <el-button>友商过滤<i class="el-icon-arrow-down el-icon--right"></i></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-checkbox-group
            v-model="filterCompetitorList"
            style="display:inline-grid;margin-left: 10px;"
            @change="handleFilterCompetitorList"
          >
            <el-checkbox
              style="display: block; margin: 0;"
              v-for="(item, index) in initCompetitorList"
              :label="item.id"
              :key="index"
              >{{ item.label }}</el-checkbox
            >
          </el-checkbox-group>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-table
      ref="function_table"
      :border="true"
      :data="viewData"
      :show-header="true"
      :column-drag-sortable="false"
      :key="params.id"
      class="sky-host-dist"
      @select="handleSelectionChange"
      @select-all="selectAllChange"
      height="580"
    >
      <el-table-column type="selection" width="55" :selectable="selectableReq"> </el-table-column>
      <el-table-column :label="$t('pocMng.functionList.featureName')" prop="name" width="215" show-overflow-tooltip>
        <div class="wsp-display-flex" slot-scope="scope" @click="showFuncDetail(scope.row)">
          <!-- <div v-if="scope.row.featureType === 'REQUIRED'" class="wsp-icon-bixuan bg-f13131 font-size-28"></div> -->
          <div class="sk-link--normal">{{ scope.row.featureName }}</div>
        </div>
      </el-table-column>

      <el-table-column
        label="功能类型"
        prop="featureType"
        width="85"
        :filter-method="filterFeatureType"
        :filters="[
          {
            text: '推荐',
            value: 'RECOMMEND'
          },
          {
            text: '必选',
            value: 'REQUIRED'
          },
          {
            text: '可选',
            value: 'OPTIONAL'
          }
        ]"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.featureType === 'REQUIRED'" type="warning">必选</el-tag>
          <el-tag v-if="scope.row.featureType === 'RECOMMEND'" type="primary">推荐</el-tag>
          <el-tag v-else type="success">可选</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="使用者角色"
        prop="userRole"
        width="100"
        :filter-method="filterUserRole"
        :filters="[
          {
            text: '使用者',
            value: '使用者'
          },
          {
            text: '运维者',
            value: '运维者'
          },
          {
            text: '决策者',
            value: '决策者'
          }
        ]"
      >
      </el-table-column>
      <el-table-column
        label="桌面架构"
        prop="desktopArch"
        width="90"
        :filter-method="filterDesktopArch"
        :filters="[
          {
            text: 'VDI',
            value: 'VDI'
          },
          {
            text: 'IDV',
            value: 'IDV'
          },
          {
            text: 'TCI',
            value: 'TCI'
          },
          {
            text: 'PC',
            value: 'PC'
          }
        ]"
      >
      </el-table-column>
      <el-table-column
        :label="$t('pocMng.functionList.valueDesc')"
        :filter-method="filterValueDesc"
        :filters="valueDescList"
        show-overflow-tooltip
        prop="valueDesc"
        width="180"
      >
      </el-table-column>
      <template v-if="!isChannel">
        <el-table-column
          :label="competitor.label"
          :prop="competitor.id"
          width="95"
          align="center"
          v-for="(competitor, competitorIndex) in formCompetitorList"
          show-overflow-tooltip
          :key="competitorIndex"
        >
          <template slot-scope="scope">
            <el-tag
              v-if="
                getCompetitivenessByFeatureAndProduct(
                  competitor.id,
                  scope.row.featureName,
                  scope.row.productVersion,
                  '优势'
                )
              "
              type="success"
              >优势</el-tag
            >
            <el-tag
              v-else-if="
                getCompetitivenessByFeatureAndProduct(
                  competitor.id,
                  scope.row.featureName,
                  scope.row.productVersion,
                  '劣势'
                )
              "
              type="warning"
              >劣势</el-tag
            >
            <span
              v-else-if="
                getCompetitivenessByFeatureAndProduct(
                  competitor.id,
                  scope.row.featureName,
                  scope.row.productVersion,
                  '持平'
                )
              "
              >持平</span
            >
            <span v-else>未知</span>
          </template>
        </el-table-column>
      </template>

      <el-table-column :label="$t('pocMng.functionList.resolveIssues')" show-overflow-tooltip prop="resolveIssues">
      </el-table-column>
      <el-table-column :label="$t('pocMng.functionList.productVersion')" show-overflow-tooltip prop="productVersion">
      </el-table-column>
      <el-table-column
        :label="$t('pocMng.functionList.limitDesc')"
        show-overflow-tooltip
        prop="limitDesc"
        v-if="!isChannel"
      >
      </el-table-column>
      <el-table-column label="操作" prop="name" width="80" v-if="!isChannel">
        <div class="wsp-display-flex" slot-scope="scope" @click="feedbackLimit(scope.row)">
          <div class="sk-link--normal">限制反馈</div>
        </div>
      </el-table-column>
    </el-table>

    <el-drawer
      ref="drawer"
      :visible="dialogVisible"
      :modal-append-to-body="false"
      :modal="false"
      :append-to-body="false"
      size="55%"
      :before-close="handleCloseDrawer"
      direction="rtl"
      class="content-feature-drawer-detail"
    >
      <div
        style="margin-top: -70px;margin-bottom: 20px;margin-left: 10px;margin-right: 60px;"
        class="wsp-padding-tb-12"
      >
        <div>
          <div
            style="background: #0052d9;margin: 12px 0;width: 6px;height: 31px;display: inline-block; margin-bottom: -10px;"
          ></div>
          <div style="display: inline-block; margin-bottom: 5px; margin-left: 8px;  font-size: large;">
            <template><span>功能说明</span> </template>
          </div>
        </div>
      </div>
      <div class="feature-detail-content">
        <div class="feature-filed-detail-item">
          <div class="item-label">功能名：</div>
          <div class="item-value">{{ showFunViewDetail.featureName }}</div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">功能类型：</div>
          <div class="item-value">
            <template>
              <el-tag v-if="showFunViewDetail.featureType === 'REQUIRED'" type="warning">{{
                lang.t(featureTypeDictionary[showFunViewDetail.featureType]).label
              }}</el-tag>
              <el-tag v-else type="success">{{
                lang.t(featureTypeDictionary[showFunViewDetail.featureType]).label
              }}</el-tag>
            </template>
          </div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">业务诉求【主打价值】：</div>
          <div class="item-value">{{ showFunViewDetail.valueDesc }}</div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">预期效果：</div>
          <div class="item-value">{{ showFunViewDetail.expectedOutcome }}</div>
        </div>
        <div class="feature-filed-detail-item" v-if="!isChannel">
          <div class="item-label">竞争力信息：</div>
          <div class="item-value">
            <div v-for="(competitor, competitorIndex) in showFunViewDetail.competitiveList" :key="competitorIndex">
              <span style="font-weight: bolder;">【友商：{{ competitor.competitorCn }}】</span>
              <template>
                <el-tag v-if="competitor.competitiveness === '优势'" type="success">
                  {{ competitor.competitiveness }}
                </el-tag>
                <el-tag v-else-if="competitor.competitiveness === '持平'" type="info">
                  {{ competitor.competitiveness }}
                </el-tag>
                <el-tag v-else type="danger"> {{ competitor.competitiveness }}</el-tag>
              </template>
              <span>{{ competitor.competitiveComparison }}</span>
            </div>
          </div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">测试说明：</div>
          <div class="item-value">{{ showFunViewDetail.schemeDesign }}</div>
        </div>
        <div class="feature-filed-detail-item" v-if="!isChannel">
          <div class="item-label">相关限制说明：</div>
          <div class="item-value">{{ showFunViewDetail.limitDesc }}</div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">解决客户问题：</div>
          <div class="item-value">{{ showFunViewDetail.resolveIssues }}</div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">价值描述：</div>
          <div class="item-value">{{ showFunViewDetail.configStep }}</div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">视频演示：</div>
          <div class="item-value">{{ showFunViewDetail.video }}</div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">PPT演示：</div>
          <div class="item-value">{{ showFunViewDetail.ppt }}</div>
        </div>
        <div class="feature-filed-detail-item">
          <div class="item-label">关联测试用例：</div>
          <div class="item-value">
            <div v-for="item in showFunViewDetail.testCaseList" :key="item">
              <span>{{ item.testCaseName }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  Button,
  Drawer,
  Pagination,
  Row,
  Col,
  Tag,
  Input,
  CheckboxGroup,
  Checkbox,
  Dropdown,
  DropdownMenu,
  DropdownItem
} from 'element-ui'

import { extend } from 'sk-ui/lib/utils/util.js'

import { action } from 'sky-engine/api/index'

import { COMMON_MNG } from '@/api/apiModules'
import { listSpecFeature, getSpecFeatureInfo } from '@/api/businessResearch'
import lang from '@/lang'
import limit from '@/store/modules/limitMng/metaData/limit'
import dictionary from '@/utils/dictionary'
export default {
  name: 'SkyFunctionTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [Drawer.name]: Drawer,
    [Pagination.name]: Pagination,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [Input.name]: Input,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  props: {
    params: {
      type: Object,
      default: function() {
        return {}
      }
    },
    productVesionId: {
      type: Array,
      default: function() {
        return []
      }
    },
    productSelectFeatureIds: {
      type: Array,
      default: function() {
        return []
      }
    },
    projectCompetitors: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    variableArr: {
      handler: function(value) {},
      deep: true
    },
    params: {
      handler: function(value) {
        this.getData()
      },
      deep: true
    },
    productSelectFeatureIds: {
      handler: function(value) {
        this.defaultSelectFunction = this.productSelectFeatureIds
        this.reloadData()
      },
      deep: true
    }
  },
  data: function() {
    return {
      dialogVisible: false,
      showFunViewDetail: {},
      specFeatureList: [],
      viewData: [],
      searchKeyword: null,
      defaultSelectFunction: this.params.selectFeatrueIds ? this.params.selectFeatrueIds : [],
      selectFunction: [],
      valueMap: {},
      pageSelectFunction: [],
      valueDescList: [],
      pageTotal: 0,
      pageSize: 5,
      page: 1,
      featureTypeDictionary: dictionary.featureType,
      lang: lang,
      reqParams: {
        matchArr: [],
        page: 0,
        limit: 1000
      },
      competitivenessList: [
        {
          text: '优势',
          value: '优势'
        },
        {
          text: '劣势',
          value: '劣势'
        },
        {
          text: '持平',
          value: '持平'
        },
        {
          text: '未知',
          value: '未知'
        }
      ],
      isChannel: this.$store.getters.baseInfo.channel,
      filterCompetitorList: [],
      initCompetitorList: []
    }
  },
  mounted() {
    if (this.productSelectFeatureIds.length > 0) {
      this.defaultSelectFunction = this.productSelectFeatureIds
    } else {
      this.defaultSelectFunction = this.params.selectFeatrueIds
    }
    this.getData()
    this.getInitCompetitorList()
  },
  methods: {
    getCompetitivenessByFeatureAndProduct(competitor, featureName, productVersion, competitiveness) {
      const versionMap = this.featureProductCompetitiveMap[featureName]
      if (!versionMap || !versionMap[productVersion]) {
        return false
      }
      const findByCompetitor = competitor => {
        return versionMap[productVersion].find(item => item.competitor === competitor)
      }
      const competitive = findByCompetitor(competitor)
      if (!competitive) {
        return false
      }
      return competitiveness === competitive.competitiveness
    },
    handleFilterCompetitorList(checkedItems) {
      //最多3个，默认都有其他
      if (checkedItems.length > 3) {
        this.$store.dispatch('OpenNotification', { message: '友商过虑最多只能选择3个', type: 'warning' })
        checkedItems.pop()
        return
      }
      this.formCompetitorList = this.initCompetitorList.filter(one => checkedItems.includes(one.id))
      this.searchReq()
    },
    filterFormCompetitors() {
      let competitors = []

      competitors = this.initCompetitorList.filter(one => {
        if (this.filterCompetitorList) {
          return this.filterCompetitorList.includes(one.id)
        }
        return false
      })

      if (competitors && competitors.length >= 3) {
        competitors = competitors.splice(0, 2)
      }
      //默认有其他，前期数据过渡
      competitors.push({ id: 'OTHER', label: '其他' })
      this.formCompetitorList = competitors
      this.filterCompetitorList = competitors.map(item => {
        return item.id
      })
    },
    getInitCompetitorList() {
      if (!this.isChannel) {
        action(COMMON_MNG, 'projectCompetitor').then(response => {
          this.initCompetitorList = response.data.content.itemArr.map(item => {
            return {
              id: item.id,
              label: item.label
            }
          })
          //过滤条件选中默认项目中的友商
          this.filterCompetitorList = this.projectCompetitors
          this.filterFormCompetitors()
        })
      }
    },
    selectableReq(row, index) {
      return row.featureType !== 'REQUIRED'
    },
    refreshTable() {
      this.getData()
    },

    getSelectId() {
      var idArr = []
      for (const iterator of this.selectFunction) {
        idArr.push(iterator.id)
      }
      return idArr
    },
    filterUserRole(value, row) {
      if (!row.userRole) {
        return false
      }
      return row.userRole.includes(value)
    },
    filterCompetitiveness(value, row) {
      if (!row.competitiveness) {
        return false
      }
      return row.competitiveness === value
    },
    filterDesktopArch(value, row) {
      if (!row.desktopArch) {
        return false
      }
      return row.desktopArch.includes(value)
    },
    filterValueDesc(value, row) {
      if (!row.valueDesc) {
        return false
      }
      return row.valueDesc === value
    },
    filterFeatureType(value, row) {
      if (!row.featureType) {
        return false
      }
      return row.featureType === value
    },
    reloadData() {
      this.searchKeyword = null
      this.getData()
    },
    searchReq() {
      this.viewData = this.specFeatureList.filter(
        data => !this.searchKeyword || data.featureName.toLowerCase().includes(this.searchKeyword.toLowerCase())
      )

      this.reloadTableSelect()
    },
    reloadTableSelect() {
      this.$nextTick(() => {
        for (const iterator of this.specFeatureList) {
          if (!this.valueMap[iterator.valueDesc]) {
            this.valueMap[iterator.valueDesc] = {
              text: iterator.valueDesc,
              value: iterator.valueDesc
            }
          }

          if (this.defaultSelectFunction && this.defaultSelectFunction.length > 0) {
            if (this.defaultSelectFunction.includes(iterator.id)) {
              this.$refs.function_table.toggleRowSelection(iterator)
            }
          } else {
            if (this.productVesionId.length == 0) {
              if (this.params.sceneType === 'COMMON_SCENE') {
                if (iterator.featureType === 'REQUIRED') {
                  this.$refs.function_table.toggleRowSelection(iterator)
                }
              }
            }
          }
        }
        this.valueDescList = []
        for (var iterator in this.valueMap) {
          this.valueDescList.push(this.valueMap[iterator])
        }
      })
    },
    removeAllNoPageFeatureId(allData, removeSourceArr) {
      var source_arr = []
      for (const element of allData) {
        source_arr.push(element.id)
      }
      const intersection = source_arr.filter(item => removeSourceArr.includes(item))
      return intersection
    },
    changeSummaryCont(item, allSpecFeature) {
      // 必选数量
      var selectFeatrueIds = this.defaultSelectFunction

      var REQUIREDList = allSpecFeature.filter(specItem => {
        return specItem.featureType === 'REQUIRED'
      })
      // 已选的必选数量
      item.requiredCont = 0
      item.requiredCont = REQUIREDList.length
      var selectREQUIREDList = allSpecFeature.filter(specItem => {
        return specItem.featureType === 'REQUIRED' && selectFeatrueIds.includes(specItem.id)
      })

      // for (const element of allSpecFeature) {
      //   if (element.featureType === 'RECOMMEND' && !selectFeatrueIds.includes(element.id)) {
      //     selectFeatrueIds.push(element.id)
      //   }
      //   if (element.featureType === 'RECOMMEND' && !this.defaultSelectFunction.includes(element.id)) {
      //     this.defaultSelectFunction.push(element.id)
      //   }
      // }

      // 推荐数量
      item.selectRequiredCont = selectREQUIREDList.length
      var RECOMMENDList = allSpecFeature.filter(specItem => {
        return specItem.featureType === 'RECOMMEND'
      })
      // 已选推荐数量
      item.recommentCont = RECOMMENDList.length
      var selectRECOMMENDList = allSpecFeature.filter(specItem => {
        return specItem.featureType === 'RECOMMEND' && selectFeatrueIds.includes(specItem.id)
      })

      item.selectRecommentCont = selectRECOMMENDList.length

      var OPTIONALList = allSpecFeature.filter(specItem => {
        return specItem.featureType === 'OPTIONAL'
      })
      // 可选的数量
      item.optionalCont = OPTIONALList.length
      var selectOPTIONALList = allSpecFeature.filter(specItem => {
        return specItem.featureType === 'OPTIONAL' && selectFeatrueIds.includes(specItem.id)
      })
      item.selectOptionalCont = selectOPTIONALList.length
      item.selectFeatrueCont = item.selectOptionalCont + item.selectRecommentCont + item.selectRequiredCont
    },
    getData() {
      this.reqParams.matchArr = []
      this.reqParams.matchArr.push({
        type: 'EXACT',
        fieldName: 'sceneId',
        valueArr: [this.params.id],
        matchRule: 'EQ'
      })
      if (this.productVesionId.length > 0) {
        this.reqParams.matchArr.push({
          type: 'EXACT',
          fieldName: 'productId',
          valueArr: this.productVesionId,
          matchRule: 'EQ'
        })
      }
      this.reqParams.page = this.page - 1

      if (this.searchKeyword) {
        this.reqParams.matchArr.push({
          type: 'FUZZY',
          fieldNameArr: ['featureName', 'valueDesc'],
          value: this.searchKeyword,
          matchRule: 'FULL'
        })
      }

      this.valueMap = {}
      listSpecFeature(this.reqParams).then(res => {
        this.specFeatureList = res.data.content.itemArr
        this.featureProductCompetitiveMap = this.buildCompetitiveMap(this.specFeatureList)
        this.viewData = this.specFeatureList

        this.pageTotal = res.data.content.total

        if (!this.searchKeyword) {
          var reqCountData = {
            requiredCont: 0
          }
          this.defaultSelectFunction = this.removeAllNoPageFeatureId(this.specFeatureList, this.defaultSelectFunction)
          this.changeSummaryCont(reqCountData, this.specFeatureList)
          reqCountData.sceneId = this.params.id
          reqCountData.total = this.pageTotal

          this.$emit('reqEnd', reqCountData)
          this.$emit('changeSelect', { sceneId: this.params.id, selectIds: this.defaultSelectFunction })
        }

        this.reloadTableSelect()
      })
    },
    buildCompetitiveMap(specFeatureList) {
      const featureMap = {}
      specFeatureList.forEach(feature => {
        if (feature.sceneId && feature.productId) {
          const featureName = feature.featureName

          if (!featureMap[featureName]) {
            const versionMap = {}
            versionMap[feature.productVersion] = feature.competitiveList
            featureMap[featureName] = versionMap
          } else {
            const versionMap = featureMap[featureName]
            if (!versionMap[feature.productVersion]) {
              versionMap[feature.productVersion] = feature.competitiveList
            }
          }
        }
      })

      return featureMap
    },
    selectAllChange(val) {
      if (val.length > 0) {
        var selectIds = val.map(one => one.id)
        this.defaultSelectFunction = selectIds
      } else {
        this.defaultSelectFunction = []
      }
      var reqCountData = {
        requiredCont: 0
      }
      this.changeSummaryCont(reqCountData, this.specFeatureList)
      reqCountData.sceneId = this.params.id
      reqCountData.total = this.pageTotal

      this.$emit('reqEnd', reqCountData)

      this.$emit('changeSelect', { sceneId: this.params.id, selectIds: this.defaultSelectFunction })
    },
    handleSelectionChange(val, row) {
      this.selectFunction = val
      var ids = this.getSelectId()
      if (ids.includes(row.id)) {
        if (!this.defaultSelectFunction.includes(row.id)) {
          this.defaultSelectFunction.push(row.id)
        }
      } else {
        this.defaultSelectFunction = this.defaultSelectFunction.filter(one => one !== row.id)
      }
      var reqCountData = {
        requiredCont: 0
      }
      this.changeSummaryCont(reqCountData, this.specFeatureList)
      reqCountData.sceneId = this.params.id
      reqCountData.total = this.pageTotal

      this.$emit('reqEnd', reqCountData)

      this.$emit('changeSelect', { sceneId: this.params.id, selectIds: ids })
    },
    showFuncDetail(rowParams) {
      getSpecFeatureInfo({ id: rowParams.id }).then(res => {
        this.dialogVisible = true
        this.showFunViewDetail = res.data.content
      })
    },
    feedbackLimit(rowParams) {
      const props = {
        params: { specId: rowParams.id },
        extraParams: {
          featureName: rowParams.featureName
        }
      }
      const limitCopy = extend(true, {}, limit)
      limitCopy.toolbar.items[1].label = '  当前功能：' + rowParams.featureName
      this.$store.dispatch('OpenDetailDialog', {
        metaData: limitCopy,
        props
      })
    },
    handleCloseDrawer() {
      this.showFunViewDetail = {}
      this.dialogVisible = false
    },
    // size 变更 每页条数
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    //
    handleCurrentChange() {},
    handelPrev() {
      this.page--
      this.getData()
    },
    handelNext() {
      this.page++
      this.getData()
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(page-function-view) {
  height: 100%;
  .page-function-toolbar {
    .toolbar-input {
      width: 39%;
    }
    .toolbar-left {
      float: left;
    }
    .toolbar-right {
      float: right;
    }
  }
  .el-checkbox-ext {
    display: block;
    margin: 0;
  }
  .el-checkbox-group-ext {
    display: inline-grid;
    margin-left: 10px;
  }
  .el-table .cell {
    padding-left: 3px;
  }
  .content-feature-drawer-detail {
    height: 100%;

    .feature-detail-content {
      padding: 12px 24px;
      overflow-y: scroll;
      height: 86vh;
      .feature-filed-detail-item {
        display: flex;
        line-height: 28px;
        .item-label {
          text-align: right;
          font-weight: 600;
          width: 20%;
        }
        .item-value {
          width: 80%;
          word-break: break-all;
          white-space: pre-wrap;
          .item-tag {
            margin: 0 3px;
          }
        }
      }
    }
  }
}
</style>
